<template>
  <h3 style="text-align: center;">NewDetails</h3>
</template>

<script setup>
</script>